import Vue from 'vue'
import VueApollo from 'vue-apollo'
import { ApolloClient } from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { setContext } from 'apollo-link-context'
// Config environments
import { config } from './config'

const authLink = setContext(async (_, { headers }) => {
  let phone = ''
  let token = null

  try {
    phone = localStorage.getItem('CognitoIdentityServiceProvider.' + config.userPoolWebClientId + '.LastAuthUser')
    token = localStorage.getItem('CognitoIdentityServiceProvider.' + config.userPoolWebClientId + '.' + phone + '.idToken')
  } catch (err) {
    return err
  }

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : ''
    }
  }
})

const httpLink = new HttpLink({ uri: config.endPointGraphQL })

export const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache()
})

const apolloProvider = new VueApollo({
  defaultClient: apolloClient
})

Vue.use(VueApollo)

export default apolloProvider
